/**
 * Input2 - Simple checkbox with label (no onChange)
 *
 * Similar to Input1 but without an onChange handler; purely presentational.
 * Used for static checklist items.
 *
 * @param {Object} props
 * @param {boolean} props.checked - Whether checkbox is checked by default
 * @param {string} props.text - Label text displayed next to checkbox
 * @returns {React.ReactElement} Rendered checkbox list item
 */
function Input2({checked , text}){
  return(
    <li className="list-group-item border-0 px-0">
      <div className="form-check form-check-info text-left">
        <input className="form-check-input" type="checkbox" value="" defaultChecked={checked}/>
        <label className="form-check-label" >
          {text}
        </label>
      </div>
    </li>
  )
}
export default Input2